import {orderBy} from 'lodash';

let allTM = `Small Molecule,mAb,Vaccine,AntagoNAT,
            ASO,Cell Therapy,Gene Therapy,Olegonucleotide,
            Peptide,RNAi,Stem Cell,Large Molecule`
            .split(',').map(item => { return { _id: item.trim(), name: item.trim() } });

allTM = orderBy(allTM, ['name'], ['asc']);

export default allTM;